import React from 'react';
import { LazyImage } from '../../../project/lazy-image';

const TeeTimesWidgetFooter = ({ linkText, linkUrl, patronLogo }) => {
    if (!linkUrl || !linkText) return null;

    return (
        <div className="tee-times-widget-footer__footer">
            <a
                className="tee-times-widget-footer__full-tee-times-link"
                href={linkUrl}
                rel="noopener noreferrer"
            >{linkText}</a>
            {
                (patronLogo) &&
                <div className="tee-times-widget-footer__patron of-contain">
                    <LazyImage image={patronLogo} />
                </div>
            }
        </div>
    );
};

export default TeeTimesWidgetFooter;
